import { gql } from '@apollo/client' ;

export default gql`
  query practitioners($search: String) {
    practitioners(search: $search) {
      id
      name
      given
      family
    }
  }
`;
